export const CHANGE_PASSWORD_STARTED = 'CHANGE_PASSWORD/STARTED';
export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD/RESET';
export const CHANGE_PASSWORD_SUCCEED = 'CHANGE_PASSWORD/SUCCEED';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD/FAILED';
